import React from 'react';
import PropTypes from 'prop-types';
import MainGridMiddleLeftRowDayOffTypeSlot from './MainGridMiddleLeftRowDayOffTypeSlot';

/**
 * MainGridMiddleLeftDayOffTypeSlot
 */
class MainGridMiddleLeftDayOffTypeSlot extends React.Component {

  render() {
    const toK015Param = this.props.toK015Param;
    const MainGridNodes = this.props.dataDayOff.map((maingrid, index) => {
      return (
        <MainGridMiddleLeftRowDayOffTypeSlot dataDayOffItem={maingrid} toK015Param={toK015Param} key={index} index={index} />
      );
    });

    return (
      <div className="ledger_sheet_scroll return_y fixed_width ib vt bar bar_xy bar_y_hidden fixed_left" onScroll={e => this.props.actions.onScroll(e.target)}>
        <div className="ledger_sheet_scroll_inner max_height_target max_height_day">
          <div className="modlue left_col textleft border_b">
            {MainGridNodes}
          </div>
        </div>
      </div>
    );
  }
}

MainGridMiddleLeftDayOffTypeSlot.propTypes = {
  dataDayOff: PropTypes.any.isRequired,
  toK015Param: PropTypes.any.isRequired,
};

export default MainGridMiddleLeftDayOffTypeSlot;
